import { message } from 'antd';

/**
 * 错误处理工具类
 */
export class ErrorHandler {
  /**
   * 处理API错误
   * @param {Error} error - 错误对象
   * @param {string} defaultMessage - 默认错误消息
   */
  static handleApiError(error, defaultMessage = '操作失败') {
    const errorMessage = error.message || defaultMessage;
    message.error(errorMessage);
    console.error('API Error:', error);
  }

  /**
   * 处理验证码相关错误
   * @param {Error} error - 错误对象
   * @param {string} action - 操作类型 ('send' | 'verify')
   */
  static handleVerificationError(error, action = 'send') {
    const actionMap = {
      send: '发送验证码失败',
      verify: '验证码验证失败'
    };
    this.handleApiError(error, actionMap[action]);
  }

  /**
   * 处理认证相关错误
   * @param {Error} error - 错误对象
   * @param {string} action - 操作类型 ('login' | 'register' | 'reset')
   */
  static handleAuthError(error, action = 'login') {
    const actionMap = {
      login: '登录失败',
      register: '注册失败',
      reset: '密码重置失败'
    };
    this.handleApiError(error, actionMap[action]);
  }
}

/**
 * 表单验证工具类
 */
export class FormValidator {
  /**
   * 验证密码确认
   * @param {string} password - 原密码
   * @param {string} confirmPassword - 确认密码
   * @returns {Promise}
   */
  static validatePasswordConfirm(password, confirmPassword) {
    if (password === confirmPassword) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('两次输入的密码不一致'));
  }

  /**
   * 验证手机号格式
   * @param {string} phone - 手机号
   * @returns {boolean}
   */
  static validatePhone(phone) {
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  }

  /**
   * 验证用户协议
   * @param {boolean} agreed - 是否同意
   * @returns {Promise}
   */
  static validateAgreement(agreed) {
    if (agreed) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('请同意用户协议'));
  }
}